// extracted by mini-css-extract-plugin
module.exports = {"container":"ProgressBar_container__aaU_v","completedRectangle":"ProgressBar_completedRectangle__iA1CL"};